import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initCarouselScrollAnimations() {
  const section = document.querySelector("#learn-more");
  const itemsContainer = document.querySelector(".scroll-items");

  if (!section || !itemsContainer) return;

  const totalScrollHeight = itemsContainer.scrollHeight - itemsContainer.parentElement.offsetHeight;

  let mm = gsap.matchMedia();

  mm.add("(min-width: 1300px)", () => {

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#learn-more",
        start: "top top",
        end: "+=3000",
        pin: true,
        scrub: 1
      }
    });

    tl.to(itemsContainer, {
      y: -totalScrollHeight,
      ease: "none"
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initCarouselScrollAnimations();
});